"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var globalConfig;
(function (globalConfig) {
    globalConfig["global_config_host"] = "global_config_host";
    globalConfig["global_config_prefix"] = "global_config_prefix";
})(globalConfig || (globalConfig = {}));
//# sourceMappingURL=types.js.map